// extracted by mini-css-extract-plugin
export default {"main_footer":"footer_main_footer__CQQwP"};